import React from 'react';
import { Table, Button, Form } from 'react-bootstrap';

export default function TabelaComponentes({
    componentes,
    carrinho,
    onAdicionar,
    onRemover,
    onAtualizarQtd
}) {

    const getItemCarrinho = (id) =>
        carrinho.find(i => i.componente === id);

    return (
        <Table striped bordered>
            <thead>
                <tr>
                    <th>Nome</th>
                    <th>Categoria</th>
                    <th>Descrição</th>
                    <th>Qtd</th>
                    <th>Ação</th>
                </tr>
            </thead>
            <tbody>
                {componentes.map(c => {
                    const item = getItemCarrinho(c._id);

                    return (
                        <tr key={c._id}>
                            <td>{c.nome}</td>
                            <td>{c.categoria}</td>
                            <td>{c.descricao}</td>
                            <td style={{ width: 90 }}>
                                <Form.Control
                                    type="number"
                                    min={1}
                                    value={item?.qtd || 1}
                                    disabled={!item}
                                    onChange={e =>
                                        onAtualizarQtd(c._id, Number(e.target.value))
                                    }
                                />
                            </td>
                            <td style={{ width: 130 }}>
                                {!item ? (
                                    <Button
                                        onClick={() => onAdicionar(c._id, 1)}
                                    >
                                        Selecionar
                                    </Button>
                                ) : (
                                    <Button
                                        variant="danger"
                                        onClick={() => onRemover(c._id)}
                                    >
                                        Remover
                                    </Button>
                                )}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
}
